import { useContext } from 'react';

import { MessageContext } from '@/helpers/MessageProvider';
import useTelemetryData from '@/hooks/useTelemetryData';

const useCameraCommand = () => {
  const { publishCommand } = useContext(MessageContext);
  const { getAddress } = useTelemetryData();

  const gimbalMove = (robot, pitch, yaw) => {
    const address = getAddress(robot.id);
    publishCommand(robot, 'camera/gimbal/move', [[...address, pitch, yaw]]);
  };

  const gimbalReset = (robot) => {
    const address = getAddress(robot.id);
    publishCommand(robot, 'camera/gimbal/reset', [[...address], [...address]]);
  };

  const shoot = () => (robot) => {
    const address = getAddress(robot.id);
    const execute = () => publishCommand(robot, 'camera/shoot', [[...address]]);

    return {
      execute,
      topic: `${robot.id}/telemetry/commandAck`,
      isMatch: (data) => data.command === 203,
      isSuccess: (data) => data.result === 0,
    };
  };

  return {
    gimbalMove,
    gimbalReset,
    shoot,
  };
};

export default useCameraCommand;
